import React from 'react';
import {EfeUserContextType} from 'commons/types/Types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const UserContext = React.createContext<EfeUserContextType>({});

export function useUserContext() {
    return React.useContext(UserContext);
}

export default UserContext;
